import {z} from 'zod';
import {
	editRemovesFromFilter,
	getDefaultFilters,
	makeOptionalPropsNullable,
	type EditRemovesFromFilterParams,
	type GetDefaultFiltersParams,
} from '@netx/core-next/schema';
import {GroupSchema, type ISystemGroup, GroupField} from './groupSchema';

export const GroupFilterSchema = makeOptionalPropsNullable(
	GroupSchema.partial().pick({
		[GroupField.name]: true,
	}),
);

export const GroupsFilterableField = GroupFilterSchema.keyof().enum;

export const GROUP_FILTERABLE_FIELDS = Object.values(GroupsFilterableField);

export type GroupsFilter = z.infer<typeof GroupFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getGroupsDefaultFilters = (
	params?: Omit<GetDefaultFiltersParams<GroupsFilter>, 'filterableFields'>,
): GroupsFilter =>
	getDefaultFilters({
		...params,
		filterableFields: GROUP_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const groupEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<ISystemGroup, GroupsFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: GroupSchema,
	});
